import React, { useState, useContext, useEffect } from "react";
import Filters from "../../components/list/Filters";
import ListComponent from "../../components/list/ListComponent";
import Main from "../../components/main/Main";
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
  pushToParams,
  addActiveFn
} from "../../components/action-buttons/ActionButtonGenerator";
import CurrencyInput from "../../components/form-fields/CurrencyInput";
import Select from "../../components/form-fields/Select";
import TextInput from "../../components/form-fields/TextInput";
import TextArea from "../../components/form-fields/TextArea";
import MultiSelect from "../../components/form-fields/MultiSelect";
import { Field } from "formik";
import FileUpload from "../../components/fields/FileUpload";
import { Accordion, Button, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next"; /* Added Line */
import DocumentUpdate from "../home/document-update/DocumentUpdate";
import ReactDatePicker from "../../components/form-fields/ReactDatePicker";
import { formatListWithParameter, formatCompanyList, formatShortDate, formatmarkInfo } from "../../utils";
import request from "../../services/request";
import { ThemeContext } from '../../../context/ThemeContext';
import Checkbox from "../../components/form-fields/Checkbox";



function Sozlesmeler() {
  const { changeSpinnerStatus } = useContext(ThemeContext);
  const [configData, setConfigData] = useState(null);
  const [activeIndicatorInLeftPosition, setActiveIndicatorInLeftPosition] =
    useState("");
  const [t, i18n] = useTranslation(); /* Added Line */
  const [showModal, setShowModal] = useState(false);
  const [refreshList, setRefreshList] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [filters, setFilters] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [yurtici, setYurtici] = useState(-1);
  const [sirketDurumu, setSirketDurumu] = useState(-1);
  const [groups, setGroups] = useState(null);
  const [departmanId, setDepartmanId] = useState(null);

  const onGroupChanged = (groupIds) => {
    getCompanies(groupIds);
  };

  const getCompanies = (companyGroupIds, yurtBilgi) => {
    request({
      url: "company/multi-company",
      method: "POST",
      data: {
        body: {
          companyGroupIds: [companyGroupIds],
        },
      },
    }, changeSpinnerStatus).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        setCompanies(response.body.tableData);
      }
    });
  };

  const onUpdateButtonClicked = (selectedRow) => {
    setShowModal(true);
    setIsUpdating(true);
    setSelectedRow(selectedRow);
  };

  const linkFollow = (cell, row, rowIndex, formatExtraData) => {
    return (
      <Button className="btn-xs"
        onClick={() => {
          onUpdateButtonClicked(row);
        }}
      >
        <i className="fa fa-search color-white"></i>
      </Button>
    );
  };

  useEffect(() => {

    if (!configData) {
      return;
    }

    let data = configData?.grupSirketleri;
    
    if (yurtici != -1) {
      data = data.filter(grup => grup.yurtici == yurtici);
    }

    if (sirketDurumu != -1) {
      data = data.filter(grup => grup.isActive == (sirketDurumu == 90));
    }

    setGroups([...data]);
  }, [sirketDurumu, yurtici]);

  return (
    <Main>
      <div className="row">
        <div className="col-md-12">
          <Accordion
            className="accordion accordion-rounded-stylish accordion-bordered"
            defaultActiveKey="0"
          >
            <div className="accordion__item" key={"filter"}>
              <Accordion.Toggle
                as={Card.Text}
                eventKey={"filter"}
                className={`accordion__header ${
                  activeIndicatorInLeftPosition === "filter" ? "" : "collapsed"
                } accordion__header--primary`}
                onClick={() =>
                  setActiveIndicatorInLeftPosition(
                    activeIndicatorInLeftPosition === "filter" ? "" : "filter"
                  )
                }
              >
                <span className="accordion__header--icon"></span>
                <span className="accordion__header--text">
                  {t("sozlesmeler.filtreleme")}
                </span>
                <span className="accordion__header--indicator"></span>
              </Accordion.Toggle>
              <Accordion.Collapse
                eventKey={"filter"}
                className="accordion__body"
              >
                <div className="accordion__body--text">
                  <Filters
                    configPointUrl="sozlesmeler/config"
                    configParameterName="talepTurId"
                    configParameterValue={
                      selectedRow && selectedRow.talep.talepTurId
                    }
                    configReqType={"POST"}
                    setConfigData={(data) => setConfigData(data)}
                    setRefreshList={setRefreshList}
                    refreshList={refreshList}
                    setFilters={setFilters}
                  >
                    <Field
                        name="yurtici"
                        label={t("demandList.yurtici")}
                        colNumber="3"
                        component={Select}
                        placeholder={t("formFields.allPlaceHolder")}
                        options={configData && configData.yurtici}
                        onChangeFunc={(value) => {
                          let val = null;
                          if (value && value === 1) {
                            val = true;
                          } else if (value && value === 2) {
                            val = false;
                          }
                          setYurtici(val);
                        }}
                    />
                    <Field
                        name="sirketDurumu"
                        label={t("demandList.sirketDurumu")}
                        colNumber="3"
                        component={Select}
                        placeholder={t("formFields.allPlaceHolder")}
                        options={configData && configData.sirketDurumu}
                        onChangeFunc={(value) => { 
                          setSirketDurumu(value);
                        }}
                    />
                    <Field
                        name="isSubsidiary"
                        label={t("demandList.istirakSirketleri")}
                        colNumber="3"
                        component={Select}
                        placeholder={t("formFields.allPlaceHolder")}
                        options={configData && configData.isSubsidiary}
                    />
                    <Field
                      name="dosyaNo"
                      label={t("demandList.sozlesmeNo")}
                      colNumber="3"
                      component={TextInput}
                    />
                    <Field
                      name="departmanID"
                      label={t("documentTypes.departman")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.departmanlar}
                      onChangeFunc={(val) => setDepartmanId(val) }
                    />
                    <Field
                      name="islemNo"
                      label={t("sozlesmeler.islemNo")}
                      colNumber="3"
                      component={TextInput}
                    />
                    <Field
                      name="dosyaTuru"
                      label={t("sozlesmeler.dosyaTuru")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={
                        ((configData && configData.dosyaTurleri) || []).filter(a => departmanId ? a.otherValue == departmanId : true)
                      }
                    />
                    <Field
                      name="dosyaDurum"
                      label={t("sozlesmeler.durum")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.dosyaDurum}
                    />
                    <Field
                      name="group"
                      label={t("sozlesmeler.grup")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={
                        groups || (configData && configData.grupSirketleri)
                      }
                      onChangeFunc={(opt) => onGroupChanged(opt)}
                    />
                    <Field
                      name="sirketId"
                      label={t("sozlesmeler.grupSirketi")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={
                        companies.length > 0
                          ? companies.map((c) => {
                              return { value: c.id, label: c.name };
                            })
                          : configData && configData.sirketler
                      }
                    />
                    <Field
                      name="konu"
                      label={t("sozlesmeler.konu")}
                      colNumber="3"
                      component={TextInput}
                    />
                    <Field
                      name="taraf"
                      label={t("demandList.karsiTaraf")}
                      colNumber="3"
                      component={TextInput}
                    />
                    <Field
                      name="dil"
                      label={t("sozlesmeler.dil")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.diller}
                    />
                    <Field
                      name="avukatId"
                      label={t("sozlesmeler.avukat")}
                      colNumber="3"
                      component={MultiSelect}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.users}
                    />
                    <Field
                      name="szlThmBedelTuru"
                      label={t("sozlesmeler.tahminiBilgi")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.szlTahminiBedelTurleri}
                    />
                    <Field
                      name="paraBirimi"
                      label={t("sozlesmeler.paraBirimi")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.paraBirimleri}
                    />
                    <Field
                      name="basBedel"
                      label={t("sozlesmeler.baslangicBedel")}
                      colNumber="3"
                      component={CurrencyInput}
                      /*required*/
                    />
                    <Field
                      name="bitisBedel"
                      label={t("sozlesmeler.bitisBedel")}
                      colNumber="3"
                      component={CurrencyInput}
                      /*required*/
                    />
                    <Field
                      name="acilisTarihiMin"
                      label={t("sozlesmeler.baslangicTarihi")}
                      colNumber="3"
                      component={ReactDatePicker}
                      onChangeFunc={(date) => {setStartDate(date)}}
                      maxDate={endDate}
                    />
                    <Field
                      name="acilisTarihiMax"
                      label={t("sozlesmeler.bitisTarihi")}
                      colNumber="3"
                      component={ReactDatePicker}
                      onChangeFunc={(date) => {setEndDate(date)}}
                      minDate={startDate}
                    />
                    {/* <Field
                      name="onemli"
                      label={t("demandList.importantInfo")}
                      colNumber="3"
                      component={Checkbox}
                    /> */}
                  </Filters>
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <DocumentUpdate
            title={"Tamamlananlar"}
            endpoint={"dosya/guncelle"}
            okButtonText={"Kaydet"}
            refreshList={refreshList}
            setRefreshList={setRefreshList}
            showModal={showModal}
            isUpdating={isUpdating}
            selectedRow={selectedRow?.talep}
            setShowModal={setShowModal}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <ListComponent
            entityName=""
            endpoint="sozlesmeler/listele"
            keyField="id"
            refreshList={refreshList}
            customBody={{
              talepTurId: 27,
              filters: filters,
            }}
            hideSelection={true}
            columns={[
              {
                dataField: "talep.id",
                text: `${t("demandList.islemNo")}`,
                sort: true,
                headerStyle: {
                  width: 64
                }
              },
              // {
              //   dataField: "talep.onemli",
              //   text: `${t("demandList.importantInfo")}`,
              //   sort: false,
              //   formatter: formatmarkInfo,
              //   headerStyle: {
              //     width: 92
              //   }
              // },
              {
                dataField: "dosyaNo",
                text: `${t("demandList.sozlesmeNo")}`,
                sort: true,
              },
              {
                dataField: "talep.gnlTpDil.name",
                text: `${t("demandList.dil")}`,
                sort: true,
              },
              {
                dataField: "talep.bedel",
                text: `${t("demandList.bedel")}`,
                sort: true,
              },
              {
                dataField: "talep.companyGroup",
                text: `${t("demandList.grup")}`,
                formatter: (data) => formatListWithParameter(data, "name"),
                sort: true,
              },
              {
                dataField: "talep.company.name",
                text: `${t("demandList.grupSirketi")}`,
                sort: true,
              },
              /* {
                dataField: "talep.tarafCompanyList",
                values.tarafCompanyList?.map(s => { return { "companyId": s } })
                text: `${t("demandList.karsiTaraf")}`,
                sort: true,
              }, */
              {
                dataField: "talep",
                text: `${t("demandList.karsiTaraf")}`,
                sort: true,
                formatter: (data) => formatCompanyList(data, "taraf1", "tarafCompanyList"),
              },
              {
                dataField: "talep.dosyaTur.dosyaTuru",
                text: `${t("demandList.sözlesmeTuru")}`,
                sort: true,
              },
              {
                dataField: "talep.konu",
                text: `${t("demandList.konu")}`,
                sort: true,
              },
              // {
              //   dataField: "baslangicTarihi",
              //   text: `${t("demandList.baslangicTarihi")}`,
              //   sort: true,
              //   formatter: formatShortDate,
              // },
              // {
              //   dataField: "bitisTarihi",
              //   text: `${t("demandList.bitisTarihi")}`,
              //   sort: true,
              //   formatter: formatShortDate,
              // },
              {
                dataField: "talep.gnlTpParaBirimi.name",
                text: `${t("sozlesmeler.paraBirimi")}`,
                sort: true,
              },
              {
                dataField: "talep.dosyaDurum.dosyaDurum",
                text: `${t("demandList.durum")}`,
                sort: true,
              },
              {
                dataField: "talep.createdUser.fullName",
                text: `${t("demandList.ekleyen")}`,
                sort: true,
              },
              {
                dataField: "talep.cdate",
                text: `${t("demandList.eklemeTarihi")}`,
                sort: true,
                formatter: formatShortDate,
                headerStyle: {
                  width: 80
                }
              },
              {
                dataField: "talep.avukat.fullName",
                text: `${t("demandList.avukat")}`,
                sort: true,
              },
            {
              dataField: "",
              text: "İşlemler",
              formatter: linkFollow,
            }
            ]}
            actionButtonsObject={{
              actions: [
                pushToParams(ABT.EXCEL_EXPORT, {
                  requestTo: "file/download-excel-arsiv",
                  talepTurId: 27
                }),
                addActiveFn(
                  pushToParams(ABT.EDIT, onUpdateButtonClicked),
                  (row) => row.talep.departmanYoneticisiMi
                )
              ],
              generator: DefaultActionButtonGenerator,
            }}
          />
        </div>
      </div>
    </Main>
  );
}

export default Sozlesmeler;
